export default __webpack_public_path__ + "static/media/next-button2.02077d50.svg";